import React, { useState } from "react";

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import PropTypes from 'prop-types';
import { Typography } from "@material-ui/core";

ModalConfirm.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.bool.isRequired,
  question: PropTypes.array.isRequired
};
export default function ModalConfirm(props) {
  const { onClose, value: valueProp, open, question } = props;

  const handleCancel = () => {
    onClose(false);
  };

  const handleOk = () => {
    onClose(true);
  };


  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
      maxWidth="xs"
      open={open}

    >
      <DialogTitle>Bekræft eller afvis</DialogTitle>
      <DialogContent dividers>
        {question.map((item, idx) => { return <Typography key={idx} >{item}</Typography> })}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Afvis
        </Button>
        <Button onClick={handleOk}>Bekræft</Button>
      </DialogActions>
    </Dialog>
  );
}